<template>
  <div>
    <el-dialog class="auth" v-dialogDrag title="用户授权" :visible.sync="isAuthDialog" width="700px" @opened="search" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-table :data="roleTable" ref="roleTable" border size="small" stripe height="350" highlight-current-row v-loading="isLoading">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="code" label="编码" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="isAuthDialog = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="saveFun()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Auth',
  data () {
    return {
      //弹窗打开控制
      isAuthDialog: false,
      //加载中
      isLoading: false,
      //选中的用户ID
      userId: null,
      //表格数据
      roleTable: []
    }
  },
  methods: {
    //查询数据并选中用户的角色
    search: function () {
      this.isLoading = true
      //加载表格角色数据
      this.$axios.get('/sysRole/getAll').then(response => {
        this.roleTable = response
        //选中用户拥有的角色信息
        this.$axios.get('/sysUserRole/selectRoleIds', {
          params: {
            userId: this.userId
          }
        }).then(roleIds => {
          if(roleIds && roleIds.length > 0 && this.roleTable && this.roleTable.length > 0){
            this.roleTable.forEach(row => {
              if(roleIds.indexOf(row.id) != -1){
                this.$refs.roleTable.toggleRowSelection(row, true)
              }
            })
          }
          this.isLoading = false
        }).catch(error => this.isLoading = false)
      })
    },
    //确定保存
    saveFun: function(){
      let roleIds = []
      //获取选中的角色ID
      this.$refs.roleTable.selection.forEach(row => {
        roleIds.push(row.id)
      })
      //数据提交保持
      this.$axios({
        method: 'post',
        url: '/sysUserRole/setUserRole',
        data: this.$qs.stringify({
          userId: this.userId,
          roleIds: roleIds.join(',')
        })
      }).then(response => {
        this.isAuthDialog = false
        this.$message.success('授权成功~')
      })
    }
  }
}
</script>

<style>
.auth .el-dialog__body {
  padding: 10px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user/Auth.vue